// extracted by mini-css-extract-plugin
module.exports = {"root":"UserDetailPopup_root__pGUbu","name":"UserDetailPopup_name__r0wBr","number":"UserDetailPopup_number__Vvpva","success":"UserDetailPopup_success__FpYwM"};